import { IDefaultVendor, IDefaultVendorRequestPayload } from 'contacts/types';
import { mapRecordsFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { GetManyResponse } from 'core/types';
import { getQueryStringToSnakeCase } from 'core/utils';

export const getDefaultVendors = async (
  requestPayload: IDefaultVendorRequestPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<IDefaultVendor>> => {
  const { data } = await partfinitiClient.get(
    `/contacts/default-vendor-list/contacts?${getQueryStringToSnakeCase(requestPayload)}`,
    signal
  );

  return mapRecordsFromServer<IDefaultVendor>(data?.data, data?.recordsFiltered);
};
